module.exports = "../images/fishing-lodge-2-9.jpg?v=0df2e10";